import React from "react";
import { css } from "aphrodite";

export const letters = ["A", "B", "C", "D", "E", "F", "G", "H", "I",
                 "J", "K", "L", "M", "N", "O", "P", "Q", "R",
                 "S", "T", "U", "V", "W", "X", "Y", "Z"]

interface ILetterSelectorProps {
    selectedIndex: string;
    onSelected: any;
}

class LetterSelectorState {
    public readonly selectedIndex: string = "A"
}

export class LetterSelector extends React.Component<ILetterSelectorProps, LetterSelectorState> {

    constructor(props: ILetterSelectorProps){
        super(props);
        this.state = new LetterSelectorState();
    }

    public render() {
        return (
            <div className={css(styles.container)} >
                {letters.map(this.buildItem)}
            </div>
        );
    }

    private buildItem = (letter: string, index: number) => {

        let style;
        if(this.state.selectedIndex === letter){
            style = {
                backgroundColor: "#e0e0e0ff"
            }
        }else{
            style = {
                backgroundColor: "#ecececff"
            }
        }

        return (
            <div className={css(styles.item)} style={style} key={index} onClick={(event: any)=>{this.onItemClick(letter)}} >
                {letter}
            </div>
        );
    }

    private onItemClick = (letter: string) => {
        this.setState({...this.state, selectedIndex: letter})
        this.props.onSelected(letter);
    }

}

import { StyleSheet } from 'aphrodite';
export const styles = StyleSheet.create({
     container: {
         minWidth: "100%",
         display: "grid",
         gridTemplateColumns: "repeat(26,1fr)",
     },
     item: {
         lineHeight: "50px",
         textAlign: "center",
         ":hover" :{
            cursor: "pointer",
            backgroundColor : "#ecececff",
            filter: "brightness(95%)"
        }
     }  
})



// WEBPACK FOOTER //
// ./src/components/LetterSelector.tsx